module.exports = __webpack_public_path__ + "img/mir.25c86967.svg";